import { render, staticRenderFns } from "./_return.vue?vue&type=template&id=a2cd1f56&lang=pug&"
import script from "./_return.vue?vue&type=script&lang=js&"
export * from "./_return.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports